var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-simple-table',{attrs:{"fixed-header":""},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('thead',[_c('tr',[_c('th',{staticClass:"grey lighten-2 font-weight-bold subtitle-1",attrs:{"colspan":3}},[_c('span',[_vm._v("練習問題")])])])]),_c('tbody',[_c('tr',[_c('td',{staticClass:"width-2"},[_vm._v("練習問題画面")]),_c('td',[_c('router-link',{attrs:{"to":{
              name: 'List General OF Section',
              params: { section: _vm.$route.params.section },
              query: {
                season: _vm.$route.query.season,
                section: _vm.$route.query.section,
                chapter: _vm.$route.query.chapter,
                questionNo: '練習問題',
              },
            }}},[_vm._v("練習問題")])],1)])])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }